import { render } from "./Ordenes.vue?vue&type=template&id=3a614c60&ts=true"
import script from "./Ordenes.vue?vue&type=script&lang=ts"
export * from "./Ordenes.vue?vue&type=script&lang=ts"

import "./Ordenes.vue?vue&type=style&index=0&id=3a614c60&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__